import { Button } from "@mantine/core";
import { notifications } from "@mantine/notifications";
import { IconDownload } from "@tabler/icons-react";
import { toDay, USERS_REPORT_URL, useReportExport } from "src/hooks/useReportExport";
import { useAdmin } from "src/utils/useAdmin";

/** Manage Users header button: downloads every user (+ org/country distribution) as Excel. */
export const UsersReportExport = () => {
    const isAdmin = useAdmin();
    const { mutate, isPending } = useReportExport();

    if (!isAdmin) return null;

    const handleExport = () => {
        mutate(
            { url: USERS_REPORT_URL, fallbackFileName: `${toDay(new Date())}_users.xlsx` },
            {
                onSuccess: (fileName) => {
                    notifications.show({
                        title: "Users exported",
                        message: fileName,
                        color: "green",
                    });
                },
                onError: () => {
                    notifications.show({
                        title: "Export failed",
                        message: "The users could not be exported. Please try again.",
                        color: "red",
                    });
                },
            },
        );
    };

    return (
        <Button
            variant="default"
            leftSection={<IconDownload size={16} />}
            onClick={handleExport}
            loading={isPending}
        >
            Export
        </Button>
    );
};
